import React, { useState, useRef } from 'react';
import { Button, Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import { useParams } from 'react-router';
import * as Yup from 'yup';
import AttachHoverIcon from 'assets/icon/icon-icon-options-attachment_hover.svg';
import FormikInputField from 'components/common/Fields/FormikInputField';
import ProviderListTable from './ProviderListTable';
import Loader from 'components/Loader';
import {providerData} from '../../data'

const validationSchema = Yup.object({
  providerNpi: Yup.string().required('Provider Npi is required'),
});

let count=null;

const ProviderDrawer = (props) => {
  const { hasEditable = true, onClose,providerCount,setCount } = props;
  const [submitting, setSubmitting] = useState(false);
  const [providerNpiList,setNpiList]=useState([]);
  const [Count,SetProviderCount]=useState(providerCount);
  const[data,setData]=useState([])  
  
  const formikRef = useRef();

  let ProviderList=[...providerData];

  const handleSubmit = async (values, actions) => {
    const { providerNpi } = values;
    setNpiList(providerNpi.split(','));
    const { setErrors } = formikRef.current;
    if (!providerNpi.trim()) 
       return setErrors({ providerNpi: 'Enter valid Provider Npi' });
    else
    {
        setData(ProviderList);
    }
    
    setSubmitting(false);
  };   


    const onHandleClick=()=>{
        setCount(Count);
        onClose();
    };

    const onSetData=()=>{
      setData(data)
    }
 

  return (
    <>
      {hasEditable && (
        <Card className="border-0 rounded shadow-top">
          {submitting && <Loader opacity={0.01} color="black" />}
          <CardBody>
            <Formik
              initialValues={{
                providerNpi: '',
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}              
              innerRef={formikRef}
              children={(props) => {
                return (
                  <Form>
                    <Row>  
                    <Col sm="12">
                        <FormGroup>
                          <Field
                            key="providerNpi"
                            id="providerNpi"
                            name="providerNpi"
                            type="textarea"
                            autoComplete="off"
                            component={FormikInputField}
                            label="Provider NPIs"
                            placeholder="Enter Provider NPIs (Comma separated)"
                            required
                          />
                        </FormGroup>
                      </Col>               
                      </Row>
                    <div className="d-flex justify-content-end align-items-center">
                      <Button
                        size="sm"
                        color='info'
                        type="submit"
                        className="ms-auto"
                        disabled={submitting}
                      >
                        Load Provider Data
                      </Button>
                    </div>               
                  </Form>
                );
              }}
            ></Formik>
          </CardBody>
        </Card>
      )}
      <Card className='border-0 rounded-bottom-1 mt-3 table-card'>
        <CardBody>
          <ProviderListTable
            data={data}
            SetProviderCount={SetProviderCount}
          />
          <div className="d-flex justify-content-end align-items-center mt-3">
            <Button
              size="sm"
              color='primary'
              className="ms-auto"
              onClick={() => onHandleClick()}
            >
             Select
            </Button>
          </div> 
        </CardBody>
      </Card>
    </>
  );
};

export default ProviderDrawer;
